import { Component } from '@angular/core';

// Update the path below to match the actual location of the Header component
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Header } from '../../../core/components/header/header';
import { Footer } from '../../../core/components/footer/footer';
import { SideBar } from '../../../core/components/side-bar/side-bar';

@Component({
  selector: 'app-reporting',
  imports: [Header, Footer, SideBar, CommonModule, RouterModule],
  templateUrl: './reporting.html',
  styleUrl: './reporting.scss'
})
export class Reporting {

}
